  <div id="mynetwork" class="col-sm-12" tabindex="0" role="grid"  aria-label="Application dependency map"></div>
  <input type="hidden" id="resourceUri" (change)="refreshChangeTimeline()">

<div *ngIf="showNotSupport">
  {{selectedResourceType}} is not supported on Change Analysis. View other dependency resource changes to isolate potential causes to an issue.
</div>
<h5 *ngIf="showLoader">
  <span class="fa fa-circle-o-notch fa-spin spin-icon"></span> Loading change groups for {{selectedResourceId}}...
</h5>
